// Comprehensive business sectors based on industry standards
export const BUSINESS_SECTORS = [
  // Accommodation & Hospitality
  "Accommodation & Lodging",
  "Motel",
  "Hotel",
  "Bed & Breakfast",
  
  // Food & Beverage
  "Cafe",
  "Restaurant",
  "Takeaway",
  "Coffee Shop",
  "Bar & Pub",
  "Bakery",
  "Food & Drink",
  
  // Retail
  "General Retail",
  "Clothing Retail",
  "Home & Garden Retail",
  "Technology Retail",
  "Outdoor Retail",
  "Gift Shop",
  "Newsagency",
  "Homewares Store",
  "Specialty Food Retail",
  
  // Automotive
  "Automotive",
  "Car Wash & Detailing",
  "Mechanic Workshop",
  "Truck & Transport",
  
  // Health & Beauty
  "Health & Beauty",
  "Hair Salon & Barber",
  "Beauty Salon & Spa",
  "Gym & Fitness",
  "Healthcare",
  
  // Services
  "Business Services",
  "Cleaning Services",
  "Home Services",
  "Personal Services",
  "Education & Training",
  "Consulting",
  "Marketing & Advertising",
  "IT Services",
  
  // Construction & Trades
  "Construction",
  "Plumbing",
  "Painting Services",
  "Landscaping",
  
  // Manufacturing & Production
  "Manufacturing",
  "Import, Export, Wholesale",
  
  // Entertainment & Leisure
  "Entertainment",
  "Leisure & Recreation",
  "Pet Services & Grooming",
  
  // Marine & Agriculture
  "Boat & Marine",
  "Agricultural",
  
  // Digital & Online
  "Online Business",
  "E-commerce",
  
  // Other
  "Franchise",
  "Other",
].sort();

